export default __webpack_public_path__ + "fdb0e3976eb74281a0e85faa5b8902d6.svg";